export const AdminPanel = process.env.REACT_APP_PATH;
